import { render, staticRenderFns } from "./AffiliateWorkspace.vue?vue&type=template&id=5182a6a6"
import script from "./AffiliateWorkspace.vue?vue&type=script&lang=js"
export * from "./AffiliateWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports